import Input from './input.styles';
import {
  labelDecorator,
  iconDecorator,
  inputDecorator,
  errorDecorator,
  passwordDecorator,
  togglePasswordDecorator,
  reactFormDecorator,
} from '~/components/form/decorators';
import { pipe } from '~/utils/function';

export const InputField = (props: any) => <Input type="text" {...props} />;

export const IconInput = pipe(
  iconDecorator,
  labelDecorator,
  inputDecorator,
  errorDecorator,
)(InputField);

export const TextInput = pipe(
  labelDecorator,
  inputDecorator,
  errorDecorator,
)(InputField);

export const PasswordInput = pipe(
  passwordDecorator,
  labelDecorator,
  inputDecorator,
  errorDecorator,
)(InputField);

export const ViewablePasswordInput = pipe(
  togglePasswordDecorator,
  labelDecorator,
  inputDecorator,
  errorDecorator,
)(InputField);

export const ReactFormTextInput = pipe(
  labelDecorator,
  inputDecorator,
  errorDecorator,
  reactFormDecorator,
)(InputField);

export const ReactFormPassword = pipe(
  passwordDecorator,
  labelDecorator,
  inputDecorator,
  errorDecorator,
  reactFormDecorator,
)(InputField);
